import type { CaptureOptions } from "./capture.js";

/** Anything that can render a frame of itself to a PNG: a `Desktop`, a `Game`. */
export interface Capturable {
  capture(options?: CaptureOptions): Promise<Blob>;
}

/**
 * Development helper: capture a frame and POST it to the dev server's `/__snap` endpoint (see
 * `snapshotPlugin` in vite.config.ts), so GPU output can be inspected from a terminal.
 *
 * The capture and the PNG encode live in `capture.ts` and are public API; this is the thin part that
 * needs Webwin's own dev server, and it is the only part that does. Posting to `/__snap` from an app that
 * does not run this dev server just 404s.
 */
export async function snapshot(source: Capturable, name = "frame.png", maxWidth = 1400): Promise<string> {
  const blob = await source.capture({ maxWidth });
  const res = await fetch(`/__snap/${name}`, { method: "POST", body: blob });
  return res.text();
}
